import React, { Component } from 'react';
import { withRouter } from '~HOC';
import { connect } from 'react-redux';
import { injectIntl, FormattedMessage } from 'react-intl';
import { usersApi } from '../../../../services/apis';
import { Conditional, debouncing } from '../../../../utils/utility/index';
import {
  Spinner,
  EmployeeCard,
  EmployeeCredit,
  EmployeeShowDetail,
  Modal,
  Toast,
  MobileInfinityData,
} from '../../../../component';
import Pagination from 'react-js-pagination';
import FilterPanel from './filterPanel';
import '../../../../domain/profile/employeeManagement/employeeManagement.scss';

const EMPLOYEE_SALES_OPTIONS = [
  { name: 'profile.Activities', value: '' },
  { name: 'profile.mostSales', value: 1 },
  { name: 'profile.theLowestNumberOfSales', value: 2 },
  { name: 'profile.mostSalesAmount', value: 3 },
  { name: 'profile.theLowestSalesAmount', value: 4 },
  { name: 'profile.mostActivityTime', value: 5 },
  { name: 'profile.minimumActivityTime', value: 6 },
];

const ROLE_LIST_OPTIONS = [
  { name: 'profile.roles', id: 0 },
  { name: 'profile.adminitstrator', id: 10 },
  { name: 'profile.simpleuser', id: 11 },
  { name: 'profile.owner', id: 60 },
  { name: 'profile.crm', id: 63 },
  { name: 'profile.counter', id: 151 },
  { name: 'profile.accountants', id: 152 },
];

class EmployeeList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      allEmployeeList: [],
      allEmployeeListMobile: [],
      roleList: [],
      modalData: {},
      searchKey: '',
      searchPhrase: '',
      employeeSalesSelectedValue: '',
      roleIdSelectedValue: '',
      alertMessage: 'booking.servererror',
      toastState: 'danger',
      isShowDetailModal: false,
      isShowCreditModal: false,
      resetMobileData: true,
      showLoading: true,
      mobileLoading: false,
      toast: false,
      clickGrid: false,
      roleId: 0,
      totalRecords: 0,
      pageNumber: 1,
      itemPerPage: 9,
      pageRange: 6,
      //   profileId: 0,
    };
  }

  async componentDidMount() {
    this.fetchAllEmployee();
  }

  async componentDidUpdate(prevState) {
    const { clickGrid } = this.state;
    if (prevState.clickGrid !== clickGrid) {
      const elements = document.querySelectorAll('[id*="dropdown-menu"]');
      if (elements?.length) {
        elements.forEach((element) => {
          element.classList.remove('show');
        });
      }
    }
  }

  fetchAllEmployee = async () => {
    const { pageNumber, searchKey, roleId, itemPerPage, resetMobileData } =
        this.state,
      { id, totalRecordsValue } = this.props;
    let { allEmployeeListMobile } = this.state;
    try {
      const {
        payload: { data = [] },
      } = await usersApi.employeeListByProfileId({
        profileId: id,
        itemPerPage,
        pageNumber,
        data: { phrase: searchKey, departmentId: 0, roleId },
      });
      if (resetMobileData) allEmployeeListMobile = [];
      this.setState(
        {
          allEmployeeListMobile: [...allEmployeeListMobile, ...data],
          allEmployeeList: data,
          totalRecords: +data?.[0]?.totalCount,
          showLoading: false,
          resetMobileData: true,
        },
        () => {
          totalRecordsValue(+data?.[0]?.totalCount);
        },
      );
    } catch (error) {
      this.setState({ toast: true });
    } finally {
      this.setState({ mobileLoading: false });
    }
  };

  debounceSearchEmployee = debouncing(this.fetchAllEmployee, 700);

  handleSearch = ({ target: { name, value } }) => {
    this.setState(
      {
        [name]: value,
        pageNumber: 1,
        showLoading: true,
      },
      () => {
        this.debounceSearchEmployee(value);
      },
    );
  };

  handleFilterChange = (e) => {
    if (
      e.name === 'roleIdSelectedValue' &&
      e.value === this.state.roleIdSelectedValue
    ) {
      return;
    }

    if (
      e.name === 'employeeSalesSelectedValue' &&
      e.value === this.state.employeeSalesSelectedValue
    ) {
      return;
    }

    this.setState(
      {
        [e.name]: e.value,
        pageNumber: 1,
      },
      () => {
        this.fetchAllEmployee();
      },
    );
  };

  handleAction = (name, data) => {
    const { changeSelectedTab } = this.props;
    switch (name) {
      case 'showdetail':
        this.setState({
          modalData: structuredClone(data),
          isShowDetailModal: true,
        });
        break;
      case 'increaseOrEditCredentials':
        this.setState({
          modalData: structuredClone(data),
          isShowCreditModal: true,
        });

        break;
      case 'editEmployeeInformation':
        changeSelectedTab('addEmployee', data);
        break;
    }
  };

  render() {
    const {
        isShowDetailModal,
        isShowCreditModal,
        modalData,
        pageNumber,
        totalRecords,
        itemPerPage,
        allEmployeeList,
        showLoading,
        allEmployeeListMobile,
        changeSelectedTab,
        searchKey,
        toast,
        toastState,
        alertMessage,
        clickGrid,
      } = this.state,
      {
        id,
        intl,
        language: { direction, name },
      } = this.props;
    return (
      <>
        <Toast
          isOpen={toast}
          onClose={() => this.setState({ toast: false })}
          state={toastState}
          position="bottom"
          message={intl.formatMessage({
            id: alertMessage,
          })}
          direction={direction}
        />
        {isShowDetailModal && (
          <EmployeeShowDetail
            employeeData={modalData}
            changeSelectedTab={changeSelectedTab}
            profileId={id}
            updateEmploee={(isUpdate) => {
              if (isUpdate) {
                this.fetchAllEmployee();
              }
            }}
            isOpen={isShowDetailModal}
            onClose={() => {
              this.setState({ isShowDetailModal: false });
            }}
          />
        )}
        <Modal
          id="employeeCreditModal"
          isOpen={isShowCreditModal}
          onClose={() => {
            this.setState({ isShowCreditModal: false });
          }}
          modalWidth="col-12 col-xl-10 col-sm-11 mb-5"
        >
          <EmployeeCredit profileId={modalData.profileId} />
        </Modal>
        <FilterPanel
          searchKey={searchKey}
          handleSearch={this.handleSearch}
          employeeSalesOption={EMPLOYEE_SALES_OPTIONS}
          roleList={ROLE_LIST_OPTIONS}
          handleEmployeeSalesFilter={(e) => {
            this.handleFilterChange({
              name: 'employeeSalesSelectedValue',
              value: e.value,
            });
          }}
          handleRoleFilter={(e) => {
            this.handleFilterChange({
              name: 'roleIdSelectedValue',
              value: e.id,
            });
          }}
        />
        <Conditional checkRender={allEmployeeList.length > 0}>
          <div
            className="flex-fill"
            onClick={() => this.setState({ clickGrid: !clickGrid })}
          >
            <div className="d-md-flex d-none flex-wrap">
              {allEmployeeList.map((employee, employeeIndex) => {
                const {
                  firstName,
                  lastName,
                  departmentName,
                  email,
                  roleName,
                  basicInfo: { mobile, avatar = '' },
                  isActive,
                } = employee;
                const tempData = {
                  displayName: `${firstName} ${lastName}`,
                  detail: departmentName?.[name === 'fa' ? 'fa' : 'en'] || '',
                  boxValue: email,
                  roleName: roleName,
                  avatar: avatar,
                  id: employeeIndex,
                  buttonList: [
                    {
                      displayName: 'profile.message',
                      type: 'button',
                      name: 'message',
                      data: email,
                    },
                    {
                      displayName: 'profile.call',
                      type: 'popover',
                      name: 'call',
                      data: mobile,
                    },
                    {
                      displayName: '',
                      type: 'dropdown',
                      data: [
                        {
                          displayName: 'commissionmanagement.showdetail',
                          name: 'showdetail',
                          type: 'button',
                        },
                        {
                          displayName: 'profile.increaseCredit',
                          name: 'increaseOrEditCredentials',
                          type: 'button',
                        },
                        {
                          displayName: 'profile.editingInformation',
                          name: 'editEmployeeInformation',
                          type: 'button',
                        },
                      ],
                    },
                  ],
                  isActive,
                };
                return (
                  <EmployeeCard
                    key={`employee-${employeeIndex}`}
                    {...tempData}
                    customClass={`col-md-4 col-sm-6 col-12 px-md-0 px-sm-1 px-4 pb-sm-2 pb-4 pb-md-0 pt-md-4 pt-0 d-flex align-items-center justify-content-center`}
                    handleAction={(name) => this.handleAction(name, employee)}
                  />
                );
              })}
            </div>
            <MobileInfinityData
              isShowLoadingBar={this.state.mobileLoading}
              totalRecords={totalRecords}
              data={allEmployeeListMobile}
              itemPerPage={itemPerPage}
              handleCallData={() => (
                this.setState({ mobileLoading: true }),
                setTimeout(() => {
                  this.setState(
                    {
                      pageNumber: pageNumber + 1,
                      resetMobileData: false,
                    },
                    () => {
                      this.debounceSearchEmployee();
                    },
                  );
                }, 1000)
              )}
            >
              {allEmployeeListMobile.map((employee, employeeIndex) => {
                const {
                  firstName,
                  lastName,
                  departmentName,
                  email,
                  roleName,
                  isActive,
                  basicInfo: { mobile, avatar = '' },
                } = employee;
                const tempData = {
                  displayName: `${firstName} ${lastName}`,
                  detail: departmentName?.[name === 'fa' ? 'fa' : 'en'] || '',
                  boxValue: email,
                  roleName: roleName,
                  avatar: avatar,
                  id: `mobile-${employeeIndex}`,
                  buttonList: [
                    {
                      displayName: 'profile.message',
                      type: 'button',
                      name: 'message',
                      data: email,
                    },
                    {
                      displayName: 'profile.call',
                      type: 'popover',
                      name: 'call',
                      data: mobile,
                    },
                    {
                      displayName: '',
                      type: 'dropdown',
                      data: [
                        {
                          displayName: 'commissionmanagement.showdetail',
                          name: 'showdetail',
                          type: 'button',
                        },
                        {
                          displayName: 'profile.increaseCredit',
                          name: 'increaseOrEditCredentials',
                          type: 'button',
                        },
                        {
                          displayName: 'profile.editingInformation',
                          name: 'editEmployeeInformation',
                          type: 'button',
                        },
                      ],
                    },
                  ],
                  isActive,
                };
                return (
                  <EmployeeCard
                    key={`employee-mobile-${employeeIndex}`}
                    {...tempData}
                    customClass={`col-md-4 col-sm-6 w-100 px-md-0 px-sm-1 px-4 pb-sm-2 pb-4 pb-md-0 pt-md-4 pt-0 d-flex align-items-start justify-content-center`}
                    handleAction={(name) => this.handleAction(name, employee)}
                  />
                );
              })}
            </MobileInfinityData>
          </div>
        </Conditional>
        <Conditional checkRender={!showLoading && allEmployeeList.length === 0}>
          <h3 className="text-center flex-fill p-3 mt-4 text-primary">
            <FormattedMessage id="profile.notfound" />
          </h3>
        </Conditional>
        <Conditional checkRender={showLoading && allEmployeeList.length === 0}>
          <Spinner />
        </Conditional>
        {totalRecords > itemPerPage && (
          <div
            className="d-md-flex d-none justify-content-center pt-1 align-items-center w-100"
            style={{ position: 'relative', bottom: '-2px', zIndex: 0 }}
          >
            <Pagination
              pageRangeDisplayed={5}
              linkClass="page-link"
              itemClass="page-item"
              innerClass="pagination m-0 pt-4 directionInitial"
              activeClass="text-primary  active"
              activePage={pageNumber}
              itemsCountPerPage={itemPerPage}
              totalItemsCount={totalRecords}
              onChange={(pageNumber) =>
                this.setState({ pageNumber, allEmployeeListMobile: [] }, () => {
                  this.fetchAllEmployee();
                })
              }
            />
          </div>
        )}
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    language: state.language,
  };
}

export default connect(mapStateToProps)(injectIntl(withRouter(EmployeeList)));
